var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCdDemocraticRepublicoftheCongo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_9215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3 9H51L49.05 2.7L47.1 9H40.8L45.9 12.9L43.95 19.2L49.05 15.3L54.15 19.2L52.2 12.9L57.3 9ZM3.75 0L60 33.75V45H56.25L0 11.25V0H3.75Z",
    fill: "#F7D618"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L60 36V45L0 9V0Z",
    fill: "#CE1021"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_9215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdDemocraticRepublicoftheCongo);
export default __webpack_public_path__ + "static/media/cd Democratic Republic of the Congo.e728433884b4f9f16660227e347f33bc.svg";
export { ForwardRef as ReactComponent };